import { GridApi, ExcelExportParams, CsvExportParams, GridReadyEvent } from 'ag-grid-enterprise'
import React, { useRef, useCallback } from 'react'
import { useGridExport } from './useGridExport'
import { CellExportMetadataProvider } from '../../../../../shared/utils/excelJsExport/excelExportTypes'

export const useGridRegistration = (
  gridId: number,
  sheetName: string,
  exportOptions?: Partial<ExcelExportParams & CsvExportParams>,
  getCellMetadata?: CellExportMetadataProvider
) => {
  const { registerGrid, unregisterGrid } = useGridExport()
  const gridApiRef = useRef<GridApi | null>(null)

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      gridApiRef.current = params.api
      registerGrid(gridId, {
        api: params.api,
        sheetName,
        exportOptions,
        getCellMetadata
      })
    },
    [gridId, sheetName, exportOptions, getCellMetadata, registerGrid]
  )

  React.useEffect(() => {
    return () => {
      if (gridApiRef.current) {
        unregisterGrid(gridId)
      }
    }
  }, [gridId, unregisterGrid])

  return { onGridReady }
}
